module.exports = __webpack_public_path__ + "img/bookmark_white.792262a9.png";